import ErrBoundary from './core/components/ErrBoundary';
import AboutCorpCtl from './home/about/corpCtl';
import AboutStyleCtl from './home/about/styleCtl';
import AboutPosterCtl from './home/about/poster/posterCtl';
import VerityLoginCtl from './home/staff/login';
import ReportBiCtl from './report/bi/facility/biCtl';
import PageReportBiKpi from './report/bi/kpi/PageReportBiKpi';
import PageAdminPayorList from './admin/payor/list/PageAdminPayorList';
import PageAdminPayorEdit from './admin/payor/edit/PageAdminPayorEdit';
import PageAdminGroupsList from './admin/groups/list/PageAdminGroupsList';
import PageAdminGroupsCreate from './admin/groups/create/PageAdminGroupsCreate';
import PageAdminProviderList from './admin/provider/list/PageAdminProviderList';
import PageAdminProviderEdit from './admin/provider/edit/PageAdminProviderEdit';
import PageAdminMFRRestrictionsList from './admin/mfr-restrictions/list/PageAdminMFRRestrictionsList';
import PageAdminVendorList from './admin/vendor/list/PageAdminVendorList';
import PageAdminVendorEdit from './admin/vendor/edit/PageAdminVendorEdit';
import PageAdminIraList from './admin/ira/list/PageAdminIraList';
import PageOpsFeedsList from './ops/feeds/list/PageOpsFeedsList';
import PageOpsDataMonitor from './ops/datamonitor/list/PageOpsDataMonitor';
import PageOrdersCpOrderInvoicesList from './orders/cp-order-invoices/list/PageOrdersCpOrderInvoicesList';
import PageOrdersCpOrderInvoicesDetails from './orders/cp-order-invoices/detail/PageOrdersCpOrderInvoicesDetails';
import PageSplitOrderInvoicesList from './orders/split-order-invoices/list/PageSplitOrderInvoicesList';
import PageSplitOrderInvoicesDetails from './orders/split-order-invoices/detail/PageSplitOrderInvoicesDetails';

type RouteObject = {
    name: string;
    parent?: string;
    abstract?: boolean;
    skipAuth?: boolean;
    url: string;
    component?: () => JSX.Element;
    params?: {
        tab?: string | null;
        Id?: string | null;
        id?: string | null;
        lineitemselected?: any | null;
        rebatesOnly?: boolean | null;
        MonitorType?: string | null;
    };
    routeInfo?: {
        title?: string;
    };
};

export default function loadReactRoutes(): RouteObject[] {
    return [
        {
            name: 'about',
            parent: 'espui',
            abstract: true,
            skipAuth: true,
            url: '/about',
            component: ErrBoundary,
        },
        {
            name: 'about.corp',
            url: '/corporate',
            skipAuth: true,
            component: AboutCorpCtl,
            params: {
                tab: null,
            },
            routeInfo: {
                title: 'About Verity',
            },
        },
        {
            name: 'about.style',
            url: '/style',
            component: AboutStyleCtl,
            routeInfo: {
                title: 'Style',
            },
        },
        {
            name: 'about.poster',
            url: '/poster',
            component: AboutPosterCtl,
            routeInfo: {
                title: 'Poster',
            },
        },
        {
            name: 'reports',
            parent: 'espui',
            abstract: true,
            url: '/reports',
            component: ErrBoundary,
        },
        {
            name: 'bi',
            parent: 'espui',
            abstract: true,
            url: '/analytics',
            component: ErrBoundary,
        },
        {
            name: 'bi.facility',
            url: '',
            component: ReportBiCtl,
            routeInfo: {
                title: 'Facility Report',
            },
        },
        {
            name: 'bi.kpi',
            url: '/kpi',
            component: PageReportBiKpi,
            routeInfo: {
                title: 'KPI Report',
            },
        },
        {
            name: 'verity',
            parent: 'espui',
            abstract: true,
            skipAuth: true,
            url: '/verity',
            routeInfo: {
                title: 'Verity',
            },
            component: ErrBoundary,
        },
        {
            name: 'verity.login',
            url: '',
            skipAuth: true,
            routeInfo: {
                title: 'Employee Login',
            },
            component: VerityLoginCtl,
        },
        {
            name: 'admin2',
            parent: 'espui',
            abstract: true,
            url: '/admin2',
            routeInfo: {
                title: 'Admin',
            },
            component: ErrBoundary,
        },
        // Admin Groups
        {
            name: 'admin2.groups',
            url: '/groups',
            abstract: true,
        },
        {
            name: 'admin2.groups.list',
            url: '',
            component: PageAdminGroupsList,
            routeInfo: {
                title: 'Group List',
            },
        },
        {
            name: 'admin2.groups.create',
            url: '/create',
            component: PageAdminGroupsCreate,
            params: {},
            routeInfo: {
                title: 'Group Create',
            },
        },
        {
            name: 'admin2.groups.update',
            url: '/update',
            component: PageAdminGroupsCreate,
            params: {
                Id: null,
            },
            routeInfo: {
                title: 'Group Update',
            },
        },
        // Admin Payor
        {
            name: 'admin2.payor',
            url: '/payor',
            abstract: true,
        },
        {
            name: 'admin2.payor.list',
            url: '',
            component: PageAdminPayorList,
            params: {
                Id: '',
            },
            routeInfo: {
                title: 'Payor List',
            },
        },
        {
            name: 'admin2.payor.create',
            url: '/create',
            component: PageAdminPayorEdit,
            params: {},
            routeInfo: {
                title: 'Payor Create',
            },
        },
        {
            name: 'admin2.payor.update',
            url: '/update',
            component: PageAdminPayorEdit,
            params: {
                Id: '',
            },
            routeInfo: {
                title: 'Payor Update',
            },
        },
        // Admin Provider
        {
            name: 'admin2.provider',
            url: '/provider',
            abstract: true,
        },
        {
            name: 'admin2.provider.list',
            url: '',
            component: PageAdminProviderList,
            params: {
                Id: '',
            },
            routeInfo: {
                title: 'Provider List',
            },
        },
        {
            name: 'admin2.provider.update',
            url: '/update',
            component: PageAdminProviderEdit,
            params: {
                Id: '',
            },
            routeInfo: {
                title: 'Provider Edit',
            },
        },
        // Admin MFR Restrictions
        {
            name: 'admin2.mfrestrict',
            url: '/mfrestrict',
            abstract: true,
        },
        {
            name: 'admin2.mfrestrict.list',
            url: '',
            component: PageAdminMFRRestrictionsList,
            params: {
                Id: '',
            },
            routeInfo: {
                title: 'MFR List',
            },
        },
        // Admin Vendor
        {
            name: 'admin2.vendor',
            url: '/vendor',
            abstract: true,
        },
        {
            name: 'admin2.vendor.list',
            url: '',
            component: PageAdminVendorList,
            params: {
                Id: '',
            },
            routeInfo: {
                title: 'Vendor List',
            },
        },
        {
            name: 'admin2.vendor.update',
            url: '/update',
            component: PageAdminVendorEdit,
            params: {
                Id: '',
            },
            routeInfo: {
                title: 'Vendor Edit',
            },
        },
        {
            name: 'admin2.vendor.create',
            url: '/create',
            component: PageAdminVendorEdit,
            params: {},
            routeInfo: {
                title: 'Vendor Create',
            },
        },
        // Admin Payor
        {
            name: 'admin2.ira',
            url: '/ira',
            abstract: true,
        },
        {
            name: 'admin2.ira.list',
            url: '',
            component: PageAdminIraList,
            routeInfo: {
                title: 'IRA List',
            },
        },
        // Operations
        {
            name: 'ops2',
            parent: 'espui',
            abstract: true,
            url: '/ops',
            component: ErrBoundary,
        },
        // Operations Feeds
        {
            name: 'ops2.feeds',
            url: '/feeds',
            abstract: true,
        },
        {
            name: 'ops2.feeds.list',
            url: '',
            component: PageOpsFeedsList,
            routeInfo: {
                title: 'Feeds List',
            },
        },
        // Operations Data Monitor
        {
            name: 'ops2.datamonitor',
            url: '/datamonitor',
            abstract: true,
        },
        {
            name: 'ops2.datamonitor.list',
            url: '',
            component: PageOpsDataMonitor,
            routeInfo: {
                title: 'Data Monitor',
            },
            // MonitorType deep-link param from the in-app alert dropdown (header.js gotoAlert)
            params: { MonitorType: null },
        },
        // CP & Split Order Invoices (React)
        {
            name: 'invoice2',
            parent: 'espui',
            abstract: true,
            url: '/invoice',
            component: ErrBoundary,
        },
        // CP Order Invoices
        {
            name: 'invoice2.cp',
            url: '/cp',
            abstract: true,
        },
        {
            name: 'invoice2.cp.list',
            url: '',
            component: PageOrdersCpOrderInvoicesList,
        },
        {
            name: 'invoice2.cpdetail',
            url: '/cpdetail',
            component: PageOrdersCpOrderInvoicesDetails,
            params: {
                Id: null,
            },
            routeInfo: {
                title: 'CP Invoice Detail',
            },
        },
        // Split Order Invoices
        {
            name: 'invoice2.split',
            url: '/split',
            abstract: true,
        },
        {
            name: 'invoice2.split.list',
            url: '',
            component: PageSplitOrderInvoicesList,
        },
        {
            name: 'invoice2.splitdetail',
            url: '/splitdetail',
            component: PageSplitOrderInvoicesDetails,
            params: { Id: null, id: null, lineitemselected: null, rebatesOnly: null },
            routeInfo: {
                title: 'Split Invoice Detail',
            },
        },
    ];
}
